import StorageInterface from './storage.interface';
import Cookie from 'js-cookie';

class CookieStorage implements StorageInterface {
    private DOMAIN = '.booninterior.com';

    constructor() {
        if (typeof window !== 'undefined' && !window.location.host.includes('booninterior.com')) {
            this.DOMAIN = null;
        }
    }

    public getItem(key: string) {
        try {
            return Cookie.get(key);
        } catch (e) {
            return false;
        }
    }

    public setItem(key: string, value: string, expires = 1) {
        try {
            return Cookie.set(key, value, { expires, domain: this.DOMAIN });
        } catch (e) {
            return false;
        }
    }

    public removeItem(key: string) {
        try {
            return Cookie.remove(key, { expires: 1, domain: this.DOMAIN });
        } catch (e) {
            return false;
        }
    }
}

export const cookieStorage = new CookieStorage();
